import React, { useEffect, useState, useContext } from "react";
import ProfileHeader from "../components/Profile/StudentProfile/ProfileHeader";
import EnrolledCoursesList from "../components/Profile/StudentProfile/EnrolledCoursesList";
import StudentsPaymentHistory from "../components/Profile/StudentProfile/StudentsPaymentHistory";
import { fetchUserProfile } from "../services/profile/profileService"; // Updated import
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import { BASE_UPLOADS } from "../utils/constants";
import { getApi } from "../services/api";

function StudentProfile() {
	const [studentProfile, setStudentProfile] = useState(null);
	const [enrolledCourses, setEnrolledCourses] = useState([]);
	const { user } = useContext(AuthContext);
	const userId = user?._id;

	useEffect(() => {
		const fetchData = async () => {
			try {
				if (!userId) {
					throw new Error("Invalid user id");
				}
				// Fetching student profile using fetchUserProfile
				const profileData = await fetchUserProfile(userId); // Fetch using userId
				setStudentProfile(profileData);

				// Fetch enrolled courses using CourseListService
				const enrollmentData = await getApi(`/enrollment/${userId}`);
				const courseData = enrollmentData.map((enrollment) => ({
					...enrollment.classroomId.courseId,
					classroomId: enrollment.classroomId._id,
				}));
				setEnrolledCourses(courseData);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();
	}, [userId]);

	const handleProfileUpdate = (updatedData) => {
		setStudentProfile((prev) => ({
			...prev,
			fullName: updatedData.name,
			email: updatedData.email,
			phone: updatedData.phone,
			profilePic: updatedData.profilePic,
		}));
		toast.success("Profile updated successfully!");
	};

	if (!studentProfile) {
		return <div className="text-center mt-20">Loading...</div>;
	}

	return (
		<div className="max-w-4xl mx-auto my-8 font-sans p-4 bg-white rounded-lg shadow-lg pt-4 mt-20">
			<ProfileHeader
				name={studentProfile.fullName}
				email={studentProfile.email}
				phone={studentProfile.phone || "No phone number provided."}
				profilePic={`${BASE_UPLOADS}/profile/${userId}/${studentProfile.profilePic}`}
				userId={userId}
				onProfileUpdate={handleProfileUpdate}
				onProfileUpdated={handleProfileUpdate}
			/>
			<EnrolledCoursesList courses={enrolledCourses} />
			<StudentsPaymentHistory userId={userId} />
		</div>
	);
}

export default StudentProfile;
